// Sitewide preview: lets admins preview an unpublished sitewide promotion by passing
// the decoded objects on the URL (?action=preview&preview-sitewide[&preview-sitewidemobile]=<b64>).
// Values are used in-memory only for the current SSR request — never fetched, cached or persisted.

// Each param is a base64-encoded, URL-encoded UTF-8 JSON string.
// `atob` is a browser/Node global but is NOT available in the SSR bundle VM sandbox,
// so fall back to Buffer on the server to decode base64 → UTF-8.
export function decodePreview(raw) {
  try {
    const b64 = decodeURIComponent(raw)
    const json = typeof atob === 'function' ? decodeURIComponent(escape(atob(b64))) : Buffer.from(b64, 'base64').toString('utf-8')
    return JSON.parse(json)
  } catch {
    return null
  }
}

function isValidSitewide(obj) {
  return !!obj && typeof obj === 'object' && typeof obj.image_url === 'string' && obj.image_url.length > 0
}

// Normalise a decoded preview payload for rendering: href falls back to "/" when empty.
// alt/title/type/enabled/image_url are carried through as-is.
function normaliseSitewide(obj) {
  return {
    ...obj,
    href: obj.href && String(obj.href).length ? obj.href : '/'
  }
}

// Resolve the desktop/mobile sitewide preview objects from a route query.
// Returns null unless action === 'preview' and at least one valid param is present.
// Each slot is independent: `preview-sitewide` → desktop, `preview-sitewidemobile` → mobile.
// A slot with no valid param is returned as null (leave the live sitewide untouched).
export function resolveSitewidePreview(query = {}) {
  if (!query || query.action !== 'preview') {
    return null
  }

  const hasParam = !!(query['preview-sitewide'] || query['preview-sitewidemobile'])
  console.log('[sitewidePreview] action=preview detected, hasParam=', hasParam)

  const decodedDesktop = decodePreview(query['preview-sitewide'])
  const decodedMobile = decodePreview(query['preview-sitewidemobile'])

  const desktop = isValidSitewide(decodedDesktop) ? normaliseSitewide(decodedDesktop) : null
  const mobile = isValidSitewide(decodedMobile) ? normaliseSitewide(decodedMobile) : null
  console.log('[sitewidePreview] decoded desktop=', desktop, 'mobile=', mobile)

  if (!desktop && !mobile) {
    console.log('[sitewidePreview] no valid preview object, falling back to published sitewide')
    return null
  }

  return {
    sitewide: desktop,
    sitewidemobile: mobile
  }
}
